import React from 'react';
import Hash from "object-hash";
import { Tbody, Thead, Tr } from "react-super-responsive-table";
import ResultRow from "./ResultRow/ResultRow";
import { HeaderTitle, StyledTable, TableHeader } from "./ResultTableStyled/ResultTableStyled";
import useWindowDimensions from "../../Sensors/useWindowDimensions";

export const ResultTableTabs = (props) => {
    const { fieldsToShow, data, type, client, setSelectedForDownload, sendPlaylistDownloadRequest, userSalesOrgs, userRoles, defaultAction, showPointer, tableUnified, downloadRequest } = props;
    const { windowWidth } = useWindowDimensions ();
    return (
        <StyledTable key={ Hash ( JSON.stringify ( data ) ) }>
            <Thead>
                <Tr>
                    { fieldsToShow && fieldsToShow.map ( ( fieldToShow, index ) => {
                        //Loop to render all fields that we want to show
                        if ( fieldToShow === "type" ) {
                            return (
                                <TableHeader key={ "type" }>
                                    <HeaderTitle/>
                                </TableHeader>
                            )
                        } else if ( fieldToShow === "size" && windowWidth < 993 ) {
                            return null
                        } else {
                            return (
                                <TableHeader
                                    key={ Hash ( fieldToShow + index ) }
                                >
                                    <HeaderTitle>{ fieldToShow === "language" ? "lang." : fieldToShow === "mimetype" ? "type" : fieldToShow }</HeaderTitle>
                                </TableHeader> )
                        }
                    } ) }
                    <TableHeader key={ "actions" }><HeaderTitle/></TableHeader>
                </Tr>
            </Thead>
            <Tbody>
                { data.length > 1 ?
                    data.map ( ( row, index ) => {
                        //Loop into the objects
                        const entityBundle = row.metadata?.entityBundle ?? null;
                        const currentId = row.id ?? null;
                        let rowId = `${entityBundle}_${currentId}`;
                        if (entityBundle === null && currentId === null) {
                            rowId = type + "_" + index;
                        }
                        return (
                            <>
                                <ResultRow
                                    fieldsToShow={ fieldsToShow }
                                    row={ row }
                                    sapFile={ row.metadata && row.metadata.entityBundle && row.metadata.entityBundle === "sap_file" }
                                    bokeccVideo={ row.metadata && row.metadata.entityBundle && row.metadata.entityBundle === "bokecc_video" }
                                    externalLink={ row.metadata && row.metadata.entityBundle && row.metadata.entityBundle === "external_link" }
                                    rowId={ rowId }
                                    key={ rowId }
                                    defaultAction={ defaultAction ? defaultAction : null }
                                    showPointer={ showPointer }
                                    index={ index }
                                    type={ type }
                                    tableUnified={ tableUnified }
                                    apolloClient={ client }
                                    setSelectedForDownload={ setSelectedForDownload }
                                    requestIncludesMe={ downloadRequest.includes ( row.uuid ) }
                                    sendPlaylistDownloadRequest={ sendPlaylistDownloadRequest }
                                    userSalesOrgs={ userSalesOrgs }
                                    userRoles={ userRoles }
                                />
                            </>
                        );
                    } )
                    :
                    <ResultRow
                        fieldsToShow={ fieldsToShow }
                        row={ data[0] }
                        sapFile={ data[0].metadata && data[0].metadata.entityBundle && data[0].metadata.entityBundle === "sap_file" }
                        bokeccVideo={ data[0].metadata && data[0].metadata.entityBundle && data[0].metadata.entityBundle === "bokecc_video" }
                        externalLink={ data[0].metadata && data[0].metadata.entityBundle && data[0].metadata.entityBundle === "external_link" }
                        rowId={ data[0].metadata && data[0].metadata.entityBundle ? `${ data[0].metadata.entityBundle }_${ data[0].id }` : `${ data[0].type }_${ data[0].id }` }
                        key={ type + "_" + data[0].id }
                        defaultAction={ defaultAction ? defaultAction : null }
                        showPointer={ showPointer }
                        index={ 0 }
                        type={ type }
                        tableUnified={ tableUnified }
                        apolloClient={ client }
                        setSelectedForDownload={ setSelectedForDownload }
                        requestIncludesMe={ downloadRequest.includes ( data[0].uuid ) }
                        sendPlaylistDownloadRequest={ sendPlaylistDownloadRequest }
                        userSalesOrgs={ userSalesOrgs }
                        userRoles={ userRoles }
                    />
                }
            </Tbody>
        </StyledTable>
    )
}
